<template>
  <v-layout style="width: 100%; height: 100%">
    <FarmList/>
  </v-layout>
</template>

<script>
import FarmList from '@/components/home/management/farm/FarmList'

export default {
    components: { FarmList }
}
</script>
